<template>

  <div class="container" id="imprintContainer">
    <div v-for="item in collection" v-html="item.paragraph" />
  </div>

</template>

<script>

    export default {
        components:{

        },
        data() {
            return {
              collection:[{"paragraph":"<p><strong>IMPRESSUM</strong></p>\n<p>&nbsp;</p>\n<p><strong>Verantwortlicher</strong></p>\n<p>Rechtlich verantwortlich f&uuml;r diese Seite gem&auml;&szlig; &sect; 5 TMG und &sect;6 TDG ist</p>\n<p>Dipl.-P&auml;d., Kinder- und Jugendlichenpsychotherapeut Nicolas Mandt</p>\n<p>&nbsp;</p>\n<p>Name und Sitz der psychotherapeutischen Praxis:</p>\n<p>Praxis Nicolas Mandt</p>\n<p>tiefenpsychologische Psychotherapie f&uuml;r Kinder, Jugendliche und junge Erwachsene</p>\n<p>Beethovenstra&szlig;e 10</p>\n<p>50674 K&ouml;ln</p>\n<p>Kontakt:</p>\n<p>Email: mail@praxismandt.de</p>\n<p>Telefon: 0176 - 44 40 14 24 </p>\n<p>&nbsp;</p>\n<p>Aufsichtsbeh&ouml;rde und zust&auml;ndige Kammer:</p>\n<p>Psychotherapeutenkammer Nordrhein-Westfalen</p>\n<p>Willst&auml;tterstra&szlig;e 10, 40549 D&uuml;sseldorf</p>\n<p>www.ptk-nrw.de &nbsp; </p>\n<p>&nbsp;</p>\n<p>Approbation erteilt durch: Bundesrepublik Deutschland</p>\n<p>Berufsbezeichnung: Kinder- und Jugendlichenpsychotherapeut</p>\n<p>Richtlinienverfahren: tiefenpsychologisch fundierte Psychotherapie</p>\n<p>Eintragung in das Arztregister: 2783349</p>\n<p>&nbsp;</p>\n<p><strong>Geltende berufsrechtliche Regelungen</strong>:</p>\n<p>- Gesetz &uuml;ber die Berufe des Psychologischen Psychotherapeuten und des Kinder- und Jugendlichenpsychotherapeuten (Psychotherapeutengesetz PsychThG), einsehbar unter:</p>\n<p>http://www.gesetze-im-internet.de/psychthg/</p>\n<p>&nbsp;</p>\n<p>- Berufsordnung der Psychotherapeutenkammer NRW, Regelungen,&nbsp;einsehbar unter:</p>\n<p>http://www.ptk-nrw.de</p>\n<p>&nbsp;</p>\n<p>- Geb&uuml;hrenordnung f&uuml;r Psychotherapie (GOP), einsehbar unter:</p>\n<p>https://www.pkv.de/service/rechtsquellen/gesetze-und-verordnungen/gebuehrenordnung-fuer-aerzte-goae.pdf</p>\n<p>&nbsp;</p>\n<p><strong>Hinweis zur Umsatzsteuer</strong></p>\n<p>Gem&auml;&szlig; &sect; 4 Nr. 14 UStG sind heilberufliche Leistungen in Form von Psychotherapie von der Umsatzsteuer befreit.</p>\n<p>&nbsp;</p>\n<p><strong>Angaben zur Berufshaftpflichtversicherung</strong>&nbsp;</p>\n<p>Barmenia Allgemeine Versicherungs-AG,</p>\n<p>Barmenia-Allee 1,</p>\n<p>42119 Wuppertal</p>\n<p>Geltungsraum der Versicherung: Deutschland&nbsp;</p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>","_mby":"5c78dbb16435630838000192","_by":"5c78dbb16435630838000192","_o":0,"_modified":1552815928,"_created":1552344127,"_id":"5c86e43f66343617ff000115","children":[]}],
            }
        },
        mounted () {
          this.$http.get(this.$store.getters.serviceClient().getCollectionUrl('contentImprint'))
            .then((response) => {
              if (response.ok) {
                console.log(response.body.entries)
                this.$data.collection = response.body.entries
              }
            })
            .catch((error) => {
              console.log(error)
            })
        },
        props: [],
        computed: {},
        methods: {}
    }

</script>

<style scoped="scoped">
  #imprintContainer{
    color:#666;
    padding-top:5em;
  }
</style>



// WEBPACK FOOTER //
// src/components/Imprint.vue